export const shallowEqual = (prev: any, props: any) =>
  prev === props ||
  (prev && props
    ? Object.keys({ ...prev, ...props }).reduce<boolean>(
        (acc, curr) => acc && prev[curr] === props[curr],
        true,
      )
    : false);
